"use client";

import * as React from "react";
import { CircleCheck, Loader } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
function ConversationFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center space-y-4 py-8 text-center animate-in fade-in zoom-in duration-500">
        <div className="rounded-full bg-primary/10 p-3">
          <CircleCheck className="size-8 text-primary" />
        </div>
        <div className="space-y-2">
          <h3 className="font-default text-xl font-semibold text-foreground">
            Request Received
          </h3>
          <p className="text-muted-foreground">{successMessage}</p>
        </div>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <FormField control={control} name="email" rules={{
      required: "Email address is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Email Address</FormLabel>
            <FormControl>
              <Input type="email" placeholder="you@example.com" className="bg-background" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone_number" rules={{
      minLength: {
        value: 10,
        message: "Please enter a valid phone number"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Phone Number Optional</FormLabel>
            <FormControl>
              <Input type="tel" placeholder="(555) 123-4567" className="bg-background" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="remarks" render={({
      field
    }) => <FormItem>
            <FormLabel>Tell us about your land</FormLabel>
            <FormControl>
              <Textarea placeholder="Describe your acreage, forest type, timber condition, or any other details that will help us..." className="bg-background" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="rounded-md border border-destructive/20 bg-destructive/10 p-3 text-sm text-destructive">
          {submitError}
        </div>}

      <Button type="submit" className="w-full" disabled={isSubmitting} size="lg">
        {isSubmitting ? <>
            <Loader className="mr-2 size-4 animate-spin" />
            Sending Request...
          </> : "Request Conversation"}
      </Button>
    </Form>;
}
export default function ConversationRequestForm() {
  return <section id="conversation-request-form" className="bg-background py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-xl">
          <Card className="border-border/50 shadow-lg">
            <CardHeader className="space-y-3 pb-8 text-center">
              <CardTitle className="font-default text-3xl font-bold tracking-tight md:text-4xl">
                Let's Talk Timber
              </CardTitle>
              <CardDescription className="mx-auto max-w-sm text-base text-muted-foreground md:text-lg">
                Tell us a bit about your land and we’ll reach out shortly. Thanks.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <FormProvider formId="conversation_request_form" sectionName="Conversation Request Form" defaultValues={{
              email: "",
              phone_number: "",
              remarks: ""
            }} successMessage="Thank you! We'll be in touch within 24 hours.">
                <ConversationFormInner />
              </FormProvider>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}